import React, { useMemo, useState } from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import { Box, CircularProgress, Typography } from "@mui/material";
import TitleBar from "components/TitleBar";
import ProcurementServiceListPopUp from "./procurementServiceListPopUp";

const Vendors = ({ data, isLoading, isError }) => {
  const [isViewTracker, setIsViewTracker] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const vendors = data?.vendors || [];

  const hasData = vendors.length > 0;

  const handleCategoryClick = (categoryName) => {

    setSelectedCategory(categoryName);
    setIsViewTracker(true);
  };

  const handleClose = () => {
    setIsViewTracker(false);
    setSelectedCategory(null);
  };

  const options = useMemo(() => {
    const categories = vendors.map((vendor) => vendor?.vendorName || "Unknown");

    const spendData = vendors.map((vendor) => Number(vendor?.totalSpend ?? 0));
    return {
      chart: {
        type: "bar",
        height: 360,
      },

      title: {
        text: null,
      },

      xAxis: {
        categories: hasData ? categories : ["No Vendors"],
        title: { text: null },
        lineWidth: 0,
        tickWidth: 0,
      },

      yAxis: {
        min: 0,
        title: {
          text: "Cost →",
          align: "low",
          rotation: 0,
        },
        gridLineWidth: 0,
        labels: { enabled: false },
      },

      tooltip: {
        formatter: function () {
          return `<b>₹ ${Highcharts.numberFormat(this.y, 2)} </b>`;
        },
      },

      plotOptions: {
        bar: {
          borderRadius: 6,
          dataLabels: {
            enabled: true,
            inside: true,
            align: "right",
            formatter: function () {
              return `₹ ${Highcharts.numberFormat(this.y, 2)} `;
            },
            style: {
              color: "#FFFFFF",
              fontWeight: "600",
              textOutline: "none",
            },
          },
          cursor: "pointer",
          point: {
            events: {
              click: function (event) {
                handleCategoryClick(this.category);
              }
            }
          }
        },
        series: {
          pointPadding: 0.25,
          groupPadding: 0.1,
        },
      },

      legend: {
        enabled: false,
      },

      credits: {
        enabled: false,
      },

      series: [
        {
          name: "Cost",
          data: hasData ? spendData : [0],
          color: "#0096FF",
        },
      ],
    };
  }, [vendors, hasData]);

  if (isLoading) {
    return (
      <Box
        sx={{
          minHeight: 300,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  if (isError) {
    return (
      <Box
        sx={{
          minHeight: 300,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Typography color="error">Failed to load vendor data.</Typography>
      </Box>
    );
  }

  return (
    <>
      <TitleBar
        title={"Top 10 Vendors - Services"}
        description={"Top 10 Vendors by Spend for Services"}
      />
      {hasData ? (
        <Box sx={{ p: 2 }}>
          <HighchartsReact highcharts={Highcharts} options={options} />
        </Box>
      ) : (
        <Box
          sx={{
            minHeight: 300,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Typography sx={{ color: "#98A2B3" }}>
            No vendor data available.
          </Typography>
        </Box>
      )}
      {isViewTracker && (
        <ProcurementServiceListPopUp
          header="Top 10 Vendors - Services"
          open={isViewTracker}
          handleClose={handleClose}
          data={{ VendorName: selectedCategory }}

        />
      )}
    </>
  );
};

export default Vendors;

// const options = {
//   chart: {
//     type: "bar",
//     height: 360,
//   },

//   title: {
//     text: null,
//   },

//   xAxis: {
//     // categories: [
//     //   "GRIL",
//     //   "GLEEDS",
//     //   "Contractor 1",
//     //   "Contractor 2",
//     //   "Contractor 3",
//     //   "Contractor 4",
//     // ],
//     categories: [
//       "Electromech",
//       // "SWANIL",
//       "Rishika Kraft Pvt Ltd",
//       "Alba Lighting",
//       "Phoenix",
//       "Mid India"
//     ],
//     title: {
//       text: null,
//     },
//     lineWidth: 0,
//     tickWidth: 0,
//   },

//   yAxis: {
//     min: 0,
//     title: {
//       text: "Cost →",
//       align: "low",
//       rotation: 0,
//       offset: 0,
//       x: 0,
//       y: 0,
//     },
//     gridLineWidth: 0,
//     labels: {
//       enabled: false,
//     },
//   },

//   tooltip: {
//     pointFormat: "<b>₹ {point.y} Cr</b>",
//   },

//   plotOptions: {
//     bar: {
//       borderRadius: 6,
//       dataLabels: {
//         enabled: true,
//         inside: true,
//         align: "right",
//         format: "₹ {y} Cr",
//         style: {
//           color: "#FFFFFF",
//           fontWeight: "600",
//           textOutline: "none",
//         },
//       },
//     },
//     series: {
//       pointPadding: 0.25,
//       groupPadding: 0.1,
//     },
//   },

//   legend: {
//     enabled: false,
//   },

//   credits: {
//     enabled: false,
//   },

//   series: [
//     {
//       name: "Cost",
//       data: [5.53, 0.37, 0.12, 0.03, 15.92],
//       color: "#0096FF",
//     },
//   ],
// };
